import * as ReactService from "@intech/react-service";
import { ContratoEntidade } from "../entidades/ContratoEntidade";
import { PrestacaoEntidade } from "../entidades/PrestacaoEntidade";
import { ModalidadeEntidade } from "../entidades/ModalidadeEntidade";
import { ContratoDisponivelEntidade } from "../entidades/ContratoDisponivelEntidade";
import { ParametrosSimulacao } from "../entidades/ParametrosSimulacao";
import { ParametrosContrato } from "../entidades/ParametrosContrato";
import { FileUploadEntidade } from "../entidades/FileUploadEntidade";
import { RelIRRFEntidade } from "../entidades/RelIRRFEntidade";

class Emprestimo extends ReactService.BaseService {
  constructor() {
    super("Emprestimo");
  }

  Buscar = () =>
    this.CreateRequest<ContratoEntidade[]>(ReactService.RequestType.GET, `Buscar`);

  BuscarAtivos = () =>
    this.CreateRequest<ContratoEntidade[]>(ReactService.RequestType.GET, `BuscarAtivos`);

  BuscarDetalhePorNumeroAno = (numero: string, ano: string) =>
    this.CreateRequest<ContratoEntidade>(ReactService.RequestType.GET, `BuscarDetalhePorNumeroAno/${numero}/${ano}`);

  BuscarPrestacoesPorNumeroAno = (numero: string, ano: string) =>
    this.CreateRequest<PrestacaoEntidade[]>(ReactService.RequestType.GET, `BuscarPrestacoesPorNumeroAno/${numero}/${ano}`);

  BuscarModalidades = () =>
    this.CreateRequest<ModalidadeEntidade[]>(ReactService.RequestType.GET, `BuscarModalidades`);

  BuscarLimiteUnicoDataCredito = (cdPlano: string) =>
    this.CreateRequest<any>(ReactService.RequestType.GET, `BuscarLimiteUnicoDataCredito/${cdPlano}`);

  BuscarParcelas = (parametros: ParametrosSimulacao) =>
    this.CreateRequest<ContratoDisponivelEntidade[]>(ReactService.RequestType.POST, `BuscarParcelas`, parametros);

  BuscarMostrarCartaoMontreal = (contrato: ContratoDisponivelEntidade) =>
    this.CreateRequest<boolean>(ReactService.RequestType.POST, `BuscarMostrarCartaoMontreal`, contrato);

  Contratar = (dados: ParametrosContrato) =>
    this.CreateRequest<string>(ReactService.RequestType.POST, `Contratar`, dados);

  Upload = (model: FileUploadEntidade) =>
    this.CreateRequest<string>(ReactService.RequestType.POST, `Upload`, model);

  GerarToken = (enviarEmail: boolean, enviarSms: boolean) =>
    this.CreateRequest<string>(ReactService.RequestType.GET, `GerarToken/${enviarEmail}/${enviarSms}`);

  BuscarListaAnoCalendarioInforme = () =>
    this.CreateRequest<Array<string>>(ReactService.RequestType.GET, `BuscarListaAnoCalendarioInforme`);

  BuscarInformePorAno = (referencia: string) =>
    this.CreateRequest<RelIRRFEntidade>(ReactService.RequestType.GET, `BuscarInformePorAno/${referencia}`);

  GerarInformePorAno = (referencia: string, enviarPorEmail: boolean) =>
    this.CreateRequest<any>(ReactService.RequestType.GET, `GerarInformePorAno/${referencia}/${enviarPorEmail}`, null, ReactService.ResponseType.Blob);

}

export const EmprestimoService = new Emprestimo();
